import React from "react";

// Inline SVG icon — replaces a 512x512 36 KiB PNG that was downloaded on every page.
// Stylized thyroid gland silhouette (butterfly shape).
export const ThyroidIcon = ({ className = "w-6 h-6", style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Thyroid"
    role="img"
    fill="currentColor"
  >
    {/* Left lobe */}
    <path d="M22 14c-7 0-12 6-12 16 0 11 5 19 12 19 5 0 8-4 9-10l1-7c0-3-1-7-3-11-2-4-4-7-7-7z" />
    {/* Right lobe (mirror) */}
    <path d="M42 14c7 0 12 6 12 16 0 11-5 19-12 19-5 0-8-4-9-10l-1-7c0-3 1-7 3-11 2-4 4-7 7-7z" />
    {/* Isthmus (center bridge) */}
    <path d="M28 28h8a3 3 0 010 6h-8a3 3 0 010-6z" />
  </svg>
);

export default ThyroidIcon;
